// NOTE: key 'ROUTING_GROUP_LIST' is used by many useSelector hooks throughout the app

import registerRoutingGroupRedux from 'app/resources/routingGroup';
import { useSelector } from 'react-redux';

const key = 'ROUTING_GROUP_LIST';

export const routingGroupListRedux = registerRoutingGroupRedux(key, ['LIST']);

export const useRoutingGroupList = () => useSelector((state) => state[key]);
